import { render, staticRenderFns } from "./ColorPickers.vue?vue&type=template&id=0a18b8f0&"
import script from "./ColorPickers.vue?vue&type=script&lang=js&"
export * from "./ColorPickers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports